/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Account_InformationInputs */

const en_common_account_information = /** @type {(inputs: Common_Account_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Information`)
};

const es_common_account_information = /** @type {(inputs: Common_Account_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información de la cuenta`)
};

/**
* | output |
* | --- |
* | "Account Information" |
*
* @param {Common_Account_InformationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_account_information = /** @type {((inputs?: Common_Account_InformationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Account_InformationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_account_information(inputs)
	return en_common_account_information(inputs)
});